<template>
  <div class="boxcard w-100">
    <v-card outlined>
      <img width="100%" :src="boxData.image.src" style="object-fit:cover">

      <v-card-text class="boxcard-description-wrapper">
        <div class="boxcard-title">{{ boxData.title }}</div>
        <div class="boxcard-description my-2">
          {{ boxData.content }}
        </div>
        <div class="boxcard-price">from RM {{ boxData.variants[0].price }}</div>
      </v-card-text>

      <v-card-actions
        class="pa-4 boxcard-actions"
        style="cursor: pointer"
        @click="showVariant = !showVariant"
      >
        <div class="boxcard-variant-title">CHOOSE VARIANT</div>

        <v-spacer></v-spacer>

        <v-icon class="boxcard-chevron">{{
          showVariant ? "mdi-chevron-up" : "mdi-chevron-down"
        }}</v-icon>
      </v-card-actions>
      <v-expand-transition>
        <div v-show="showVariant">
          <div
            class="pa-4 box-variants-wrapper"
          >
            <v-card
              @click="selectBox(variant)"
              v-for="variant in boxData.variants"
              :key="variant.id"
              class="d-flex align-center"
              :class="{'out-of-stock sold-out--sm': variant.inventory_quantity <= 0}"
              outlined
            >
              <v-avatar size="50" tile>
                <v-img
                  :src="
                    variant.image
                      ? variant.image
                      : boxData.image.src
                  "
                ></v-img>
              </v-avatar>
              <div class="d-flex flex-no-wrap justify-space-between">
                <v-card-subtitle> 
                  {{ variant.option1 }} 
                  <small v-if="variant.inventory_quantity <= 0">(Sold Out)</small>
                </v-card-subtitle>
              </div>
            </v-card>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import { ACTION_MODIFY_BOX } from "../../store/actions";
import { TYPE_SET_PRODUCT_DIALOG_ITEM, TYPE_SET_PRODUCT_DIALOG_TOGGLE } from '../../store/mutations';
export default {
  name: "hb-bab-boxcard",
  props: {
    boxData: Object,
  },
  data() {
    return {
      showVariant: false,
    };
  },
  methods: {
    selectBox(variant) {
      if(this.$store.state.delivery.delivery_date){
        this.$store.dispatch(ACTION_MODIFY_BOX, {
          product: this.boxData,
          amount: 1,
          boxContentType: "boxType",
          variant
        });
      }
      this.$emit("next");
    },
  },
  computed: {
    showDialog: {
      get() {
        this.$store.state.productDialogToggle;
      },
      set(value) {
        this.$store.commit(TYPE_SET_PRODUCT_DIALOG_ITEM, this.boxData);
        this.$store.commit(TYPE_SET_PRODUCT_DIALOG_TOGGLE, value);
      },
    },
  },
};
</script>

<style>
</style>